import { Screen } from '@tempmee/react';
import { BackButton } from '~/commonComponents';
import { ReviewForm } from './components';

export const NPSReview = () => (
  <Screen variant="standard">
    <Screen.Header start={<BackButton />} title="GoTu Experience" />
    <Screen.Body inset>
      <ReviewForm />
    </Screen.Body>
  </Screen>
);
